import {
  GET_ALL_NOTIFICATIONS,
  GET_SINGLE_NOTIFICATION,
  SET_NOTIFICATION_PAGE_INFO,
  GET_MULTIPLE_CHAT_INFO,
  UPDATE_MULTIPLE_CHAT_INFO,
  GET_CHAT_INFO,
  GET_ADMIN_CHAT_INFO,
  UPDATE_CHAT_INFO,
  UPDATE_ADMIN_CHAT_INFO,
  LOG_OUT,
} from "../../types";
import { notificationUtils } from "./notificationsUtils";

const initialState = {
  get_all_notifications: [],
  get_single_notification: [],
  active_page_info: {},
  multipleChatInfo: [],
  chatInfo: {
    messages: [],
  },
  admin_chat_Info: {
    messages: [],
  },
};

const updateChat = (state, payload) => {
  let data = [...state];
  if (state.length) {
    let index = data.findIndex((ele) => ele._id == payload._id);
    if (index >= 0) {
      data[index].messages = payload.messages;
    } else {
      data = [...data, payload];
    }
  }
  return data;
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ALL_NOTIFICATIONS:
      return {
        // ...notificationUtils(action.payload),
        ...state,
        get_all_notifications: action.payload,
      };
    case GET_SINGLE_NOTIFICATION:
      return {
        // ...notificationUtils(action.payload),
        ...state,
        get_single_notification: action.payload,
      };
    case SET_NOTIFICATION_PAGE_INFO:
      return {
        ...state,
        active_page_info: action.payload,
      };

    case GET_MULTIPLE_CHAT_INFO:
      return {
        ...state,
        multipleChatInfo: action.payload,
      };
    case UPDATE_MULTIPLE_CHAT_INFO:
      return {
        ...state,
        multipleChatInfo: updateChat(state.multipleChatInfo, action.payload),
      };
    case GET_CHAT_INFO:
      return {
        ...state,
        chatInfo: action.payload,
      };
    case GET_ADMIN_CHAT_INFO:
      return {
        ...state,
        admin_chat_Info: action.payload,
      };
    case UPDATE_CHAT_INFO:
      let existingChatData = { ...state.chatInfo };
      if (!existingChatData._id || existingChatData._id == action.payload._id) {
        existingChatData = action.payload;
      }
      if (action.payload === "reset") {
        existingChatData = initialState.chatInfo;
      }
      return {
        ...state,
        chatInfo: existingChatData,
      };
    case UPDATE_ADMIN_CHAT_INFO:
      let existingAdminChatData = { ...state.admin_chat_Info };
      if (
        !existingAdminChatData._id ||
        existingAdminChatData._id == action.payload._id
      ) {
        existingAdminChatData = action.payload;
      }
      if (action.payload === "reset") {
        existingAdminChatData = initialState.admin_chat_Info;
      }
      return {
        ...state,
        admin_chat_Info: existingAdminChatData,
      };
    case LOG_OUT: {
      return {
        ...state,
        pending: [],
        reservation: [],
        walkins: [],
      };
    }
    default:
      return state;
  }
}
